import { render, staticRenderFns } from "./message-timestamp.vue?vue&type=template&id=0c904c5c&scoped=true"
import script from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-timestamp.vue?vue&type=style&index=0&id=0c904c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c904c5c",
  null
  
)

export default component.exports